module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/lodash/entriesIn.js
// module id = 1074
// module chunks = 1